<template>
    <div>
        <div class="shadow width100 marginbottom15">
            <div class="padding20 marginbottom15">
                <p>Benieuwd hoe een dek er uit ziet? Bekijk het dekkenplan.</p>
                <div class="select-drop">
                    <select
                        class="selectpaddingsmall"
                        v-model="selectedDeckPlan"
                    >
                        <option
                            v-for="(deck, index) in deckNames"
                            :key="'deck' + index"
                            :value="index"
                        >
                            Dek {{ index }} - {{ deck }}
                        </option>
                    </select>
                </div>
                <div class="buttondeck" @click="toggleDeck">Bekijk dek</div>
            </div>
        </div>
        <div v-if="showDeckPlan" class="black" @click="toggleDeck"></div>
        <transition name="fade">
            <div v-if="showDeckPlan" class="deckplanview">
                <font-awesome-icon
                    icon="times"
                    @click="toggleDeck"
                    class="times"
                />
                <div v-if="selectedDeckPlanImage">
                    <h2>{{ deckNames[selectedDeckPlan] }}</h2>
                    <img :src="selectedDeckPlanImage" />
                </div>
                <div v-else>
                    <p>Dit dekkenplan is niet beschikbaar :(</p>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'DeckPlan',
    data: function() {
        return {
            selectedDeckPlan: 1,
            showDeckPlan: false,
        }
    },
    methods: {
        toggleDeck: function() {
            this.showDeckPlan = !this.showDeckPlan
        },
    },
    computed: {
        deckNames: function() {
            if (this.$store.state.deckNames)
                this.selectedDeckPlan = Object.keys(
                    this.$store.state.deckNames
                )[0]
            return this.$store.state.deckNames
        },
        deckImages: function() {
            return this.$store.state.deckImages
        },
        selectedDeckPlanImage: function() {
            let deckPlan = this.selectedDeckPlan
            let deckImages = this.deckImages
            if (deckImages[deckPlan]) {
                return deckImages[deckPlan]
            }
            return false
        },
    },
}
</script>

<style lang="scss">
.black {
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    position: fixed;
    background: rgba(0, 0, 0, 0.4);
    z-index: 4;
}
.buttondeck {
    margin-top: 10px;
    padding: 7px;
    background: #37b5d3;
    border: 1px solid #def7fe;
    color: #def7fe;
    text-align: center;
    font-size: 14px;
    cursor: pointer;
    font-weight: bold;
}
.times {
    position: absolute;
    z-index: 6;
    top: 10px;
    right: 25px;
    font-size: 18px;
}
.deckplanview {
    background: #fff;
    border-left: 2px solid #2178b3;
    right: 0;
    bottom: 0;
    top: 0;
    position: fixed;
    z-index: 5;
    div {
        position: relative;
        overflow-y: auto;
        padding: 40px;
        max-width: 600px;
        width: calc(100% - 80px);
        max-height: calc(100vh - 80px);
    }
}
</style>
